import { XML_ScaleAndShiftX } from "./XML_ScaleAndShiftX";
import { XML_ScaleAndShiftY } from "./XML_ScaleAndShiftY";
import { XML_Cmd4 } from "./XML_Cmd4";
import { XML_Param4 } from "./XML_Param4";
import { XML_AddLinkToPPT } from "./XML_AddLinkToPPT";
import { RoundTo3 } from "./RoundTo3.js";

export function XML_DrawSmallSubchartArrowPPT(
  x0,
  y0,
  x1,
  y1,
  x2,
  y2,
  drawElement,
  linkBookmark,
  layer,
  style
) {
  if (!drawElement.fIncludeSCArrows || linkBookmark == null) return;

  var stroke = "#000000";
  var fill = "#000000";
  if (style != null) {
    stroke = style.buttonStroke;
    fill = style.buttonFill;
  }

  x0 = XML_ScaleAndShiftX(x0, drawElement, layer);
  y0 = XML_ScaleAndShiftY(y0, drawElement, layer);
  x1 = XML_ScaleAndShiftX(x1, drawElement, layer);
  y2 = XML_ScaleAndShiftY(y2, drawElement, layer);

  y0 = drawElement.ConvertY(y0);
  y2 = drawElement.ConvertY(y2);

  XML_Cmd4("tri", RoundTo3(x0), RoundTo3(y0), RoundTo3(x1 - x0), RoundTo3(y2 - y0), drawElement);
  XML_Param4("p", fill, stroke, 1, 0, drawElement);
  XML_AddLinkToPPT(linkBookmark, drawElement);
}
